/**
 * Chatwoot 客服系统 API 端点配置
 */

module.exports = {

    //卖家查询会话列表
    BUYER_CHATWOOT_CLIENT_LIST: '/system/w/chatwoot/client/api/conversations/list',
    //创建会话
    BUYER_CHATWOOT_CLIENT_CONVERSATIONS: '/system/w/chatwoot/client/api/conversations',
    // 取历史消息
    BUYER_CHATWOOT_MESSAGE_LIST: '/system/w/chatwoot/client/api/messages/list',
    //发送消息
    BUYER_CHATWOOT_MESSAGE_SEND: '/system/w/chatwoot/client/api/messages',

    BUYER_CHATWOOT_MESSAGE_SEND_WITH_FILE: '/system/w/chatwoot/client/api/messages/sendWithFile',

    BUYER_CHATWOOT_CLIENT_API_INFO: '/system/w/chatwoot/client/api/contact/info',


    //订单列表
    BUYER_ORDER_LIST: '/b2b/w/buyerOrder/findBuyerPageList',


}
